// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3laXG","buttons":"styles_buttons__A1qiB"};